import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Apiurl from "../../Helpers/apiUrl";
import { handleApiError } from "../../Helpers/handleApiError ";
import Swal from "sweetalert2";

const getToken = () => localStorage.getItem("u_token");

export const fetchAdminDashCount = createAsyncThunk(
  "dash/fetchAdminDashCount",
  async ({ user_id, month, year, from, to, role, state, region }, { rejectWithValue }) => {
    const token = getToken();
    if (!token)
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });

    try {
      const response = await axios.get(
        `${Apiurl}admin/graph?userId=${user_id || null}&year=${year}&month=${month || null}&from=${from}&to=${to}&role=${role}&state=${state}&region=${region}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleApiError(error, "Please try again later.");
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch dashs." }
      );
    }
  }
);

export const fetchAdminDashTableData = createAsyncThunk(
  "dash/fetchAdminDashTableData",
  async ({ user_id, month, year, from, to, role, state, region, channel }, { rejectWithValue }) => {
    const token = getToken();
    if (!token)
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });

    try {
      const response = await axios.get(
        `${Apiurl}admin/dashboard?userId=${user_id || null}&year=${year}&month=${month || null}&from=${from}&to=${to}&role=${role}&state=${state}&region=${region}&channel=${channel || null}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleApiError(error, "Please try again later.");
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch dashs." }
      );
    }
  }
);

export const fetchAdminDashAnalyticsAll = createAsyncThunk(
  "dash/fetchAdminDashAnalyticsAll",
  async (filters, { rejectWithValue }) => {
    const token = getToken();
    if (!token)
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });

    try {
      const response = await axios.get(
        `${Apiurl}admin/dash-analytics-all`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: filters
        }
      );

      return response.data;
    } catch (error) {
      handleApiError(error, "Please try again later.");
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch dashboard metrics." }
      );
    }
  }
);

export const fetchClientPreview = createAsyncThunk(
  "dash/fetchClientPreview",
  async ({ page, rowsPerPage, search, role, user, from, to, month, year, selectedRegion, selectedState,selectedChannels }, { rejectWithValue }) => {
    const token = getToken();
    if (!token)
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });

    try {
      const response = await axios.get(
        `${Apiurl}admin/client-quotation?page=${page}&limit=${rowsPerPage}&search=${search || ''}&role=${role || null}&user=${user}&from=${from || null}&to=${to || null}&month=${month || null}&year=${year || null}&region=${selectedRegion}&state=${selectedState}&channel=${selectedChannels}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleApiError(error, "Please try again later.");
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch dashs." }
      );
    }
  }
);

export const fetchUserQuotePreview = createAsyncThunk(
  "dash/fetchUserQuotePreview",
  async ({ page, rowsPerPage, search, role, user, from, to, month, year, selectedRegion, selectedState, selectedChannels }, { rejectWithValue }) => {
    const token = getToken();
    if (!token)
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });

    try {
      const response = await axios.get(
        `${Apiurl}admin/user-quotation?page=${page}&limit=${rowsPerPage}&search=${search || ''}&role=${role || null}&user=${user}&from=${from || null}&to=${to || null}&month=${month || null}&year=${year || null}&region=${selectedRegion}&state=${selectedState}&channel=${selectedChannels}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleApiError(error, "Please try again later.");
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch dashs." }
      );
    }
  }
);

export const fetchCollectionPreview = createAsyncThunk(
  "dash/fetchCollectionPreview",
  async ({ page, rowsPerPage, search, role, user, from, to, month, year, selectedRegion, selectedState,selectedChannels }, { rejectWithValue }) => {
    const token = getToken();
    if (!token)
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });

    try {
      const response = await axios.get(
        `${Apiurl}admin/collection?page=${page}&limit=${rowsPerPage}&search=${search || ''}&role=${role || null}&user=${user}&from=${from || null}&to=${to || null}&month=${month || null}&year=${year || null}&region=${selectedRegion}&state=${selectedState}&channel=${selectedChannels}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleApiError(error, "Please try again later.");
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch dashs." }
      );
    }
  }
);

export const fetchMovingProductPreview = createAsyncThunk(
  "dash/fetchMovingProductPreview",
  async ({ page, rowsPerPage, search, role, user, from, to, month, year, selectedRegion, selectedState, selectedChannels }, { rejectWithValue }) => {
    const token = getToken();
    if (!token)
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });

    try {
      const response = await axios.get(
        `${Apiurl}admin/moving-product?page=${page}&limit=${rowsPerPage}&search=${search || ''}&role=${role || null}&user=${user}&from=${from || null}&to=${to || null}&month=${month || null}&year=${year || null}&region=${selectedRegion}&state=${selectedState}&channel=${selectedChannels}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleApiError(error, "Please try again later.");
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch dashs." }
      );
    }
  }
);

export const fetchG3SegementPreview = createAsyncThunk(
  "dash/fetchG3SegementPreview",
  async ({ page, rowsPerPage, search, role, user, from, to, month, year, selectedRegion, selectedState, selectedChannels }, { rejectWithValue }) => {
    const token = getToken();
    if (!token)
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });

    try {
      const response = await axios.get(
        `${Apiurl}admin/g3-product?page=${page}&limit=${rowsPerPage}&search=${search || ''}&role=${role || null}&user=${user}&from=${from || null}&to=${to || null}&month=${month || null}&year=${year || null}&region=${selectedRegion}&state=${selectedState}&channel=${selectedChannels}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleApiError(error, "Please try again later.");
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch dashs." }
      );
    }
  }
);

export const fetchG4SegementPreview = createAsyncThunk(
  "dash/fetchG4SegementPreview",
  async ({ page, rowsPerPage, search, role, user, from, to, month, year, selectedRegion, selectedState, selectedChannels }, { rejectWithValue }) => {
    const token = getToken();
    if (!token)
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });

    try {
      const response = await axios.get(
        `${Apiurl}admin/g4-product?page=${page}&limit=${rowsPerPage}&search=${search || ''}&role=${role || null}&user=${user}&from=${from || null}&to=${to || null}&month=${month || null}&year=${year || null}&region=${selectedRegion}&state=${selectedState}&channel=${selectedChannels}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleApiError(error, "Please try again later.");
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch dashs." }
      );
    }
  }
);

export const fetchG5SegementPreview = createAsyncThunk(
  "dash/fetchG5SegementPreview",
  async ({ page, rowsPerPage, search, role, user, from, to, month, year, selectedRegion, selectedState,selectedChannels }, { rejectWithValue }) => {
    const token = getToken();
    if (!token)
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });

    try {
      const response = await axios.get(
        `${Apiurl}admin/g5-product?page=${page}&limit=${rowsPerPage}&search=${search || ''}&role=${role || null}&user=${user}&from=${from || null}&to=${to || null}&month=${month || null}&year=${year || null}&region=${selectedRegion}&state=${selectedState}&channel=${selectedChannels}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleApiError(error, "Please try again later.");
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch dashs." }
      );
    }
  }
);

export const fetchTopBrandPreview = createAsyncThunk(
  "dash/fetchTopBrandPreview",
  async (_, { rejectWithValue }) => {
    const token = getToken();
    if (!token)
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });

    try {
      const response = await axios.get(
        `${Apiurl}admin/top-brand`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleApiError(error, "Please try again later.");
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch dashs." }
      );
    }
  }
);

export const fetchTodayLoginPreview = createAsyncThunk(
  "dash/fetchTodayLoginPreview",
  async (_, { rejectWithValue }) => {
    const token = getToken();
    if (!token)
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });

    try {
      const response = await axios.get(
        `${Apiurl}admin/login-user`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleApiError(error, "Please try again later.");
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch dashs." }
      );
    }
  }
);

export const fetchUserQuoteByID = createAsyncThunk(
  "dash/fetchUserQuoteByID",
  async ({ userId, page, rowsPerPage, search, role, from, to, month, year, selectedRegion, selectedState }, { rejectWithValue }) => {
    const token = getToken();
    if (!token)
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });

    try {
      const response = await axios.get(
        `${Apiurl}admin/preview/quotation?user=${userId}&page=${page}&limit=${rowsPerPage}&search=${search || ''}&role=${role || null}&from=${from || null}&to=${to || null}&month=${month || null}&year=${year || null}&region=${selectedRegion}&state=${selectedState}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleApiError(error, "Please try again later.");
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch dashs." }
      );
    }
  }
);

export const fetchOpenCollection = createAsyncThunk(
  "dash/fetchOpenCollection",
  async ({ collection, page, rowsPerPage, search, role, user, from, to, month, year, selectedRegion, selectedState,selectedChannels }, { rejectWithValue }) => {
    const token = getToken();
    if (!token)
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });

    try {
      const response = await axios.get(
        `${Apiurl}admin/preview/collection/${collection}?page=${page}&limit=${rowsPerPage}&search=${search || ''}&role=${role || null}&user=${user}&from=${from || null}&to=${to || null}&month=${month || null}&year=${year || null}&region=${selectedRegion}&state=${selectedState}&channel=${selectedChannels}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleApiError(error, "Please try again later.");
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch dashs." }
      );
    }
  }
);

export const fetchOpenSku = createAsyncThunk(
  "dash/fetchOpenSku",
  async ({ sku, page, rowsPerPage, search, role, user, from, to, month, year, selectedRegion, selectedState,selectedChannels }, { rejectWithValue }) => {
    const token = getToken();
    if (!token)
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });

    try {
      const response = await axios.get(
        `${Apiurl}admin/preview/sku-code?skuCode=${sku}&page=${page}&limit=${rowsPerPage}&search=${search || ''}&role=${role || null}&user=${user}&from=${from || null}&to=${to || null}&month=${month || null}&year=${year || null}&region=${selectedRegion}&state=${selectedState}&channel=${selectedChannels}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleApiError(error, "Please try again later.");
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch dashs." }
      );
    }
  }
);

export const fetchAsProject = createAsyncThunk(
  "dash/fetchAsProject",
  async ({ page, rowsPerPage, search, role, user, from, to, month, year, selectedRegion, selectedState,selectedChannels }, { rejectWithValue }) => {
    const token = getToken();
    if (!token)
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });

    try {
      const response = await axios.get(
        `${Apiurl}admin/preview/asQuotation?page=${page}&limit=${rowsPerPage}&search=${search || ''}&role=${role || null}&user=${user}&from=${from || null}&to=${to || null}&month=${month || null}&year=${year || null}&region=${selectedRegion}&state=${selectedState}&channel=${selectedChannels}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleApiError(error, "Please try again later.");
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch dashs." }
      );
    }
  }
);

export const fetchGroheProject = createAsyncThunk(
  "dash/fetchGroheProject",
  async ({ page, rowsPerPage, search, role, user, from, to, month, year, selectedRegion, selectedState, selectedChannels }, { rejectWithValue }) => {
    const token = getToken();
    if (!token)
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });

    try {
      const response = await axios.get(
        `${Apiurl}admin/preview/groheQuotation?page=${page}&limit=${rowsPerPage}&search=${search || ''}&role=${role || null}&user=${user}&from=${from || null}&to=${to || null}&month=${month || null}&year=${year || null}&region=${selectedRegion}&state=${selectedState}&channel=${selectedChannels}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleApiError(error, "Please try again later.");
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch dashs." }
      );
    }
  }
);

const initialState = {
  adminCountsData: [],
  adminTableData: [],
  clientPreview: [],
  userQuotePreview: [],
  collectionPreview: [],
  movingProductPreview: [],
  g3SegmentPreview: [],
  g4SegmentPreview: [],
  g5SegmentPreview: [],
  topBrandPreview: [],
  todayLoginPreview: [],
  userQuoteById: [],
  openSkuUses: [],
  openColletionSkus: [],
  asProject: [],
  groheProject: [],
  analyticsAll: {},
  getStatus: "idle",
  analyticsStatus: "idle",
  error: null,
  totalCount: 0
};

const dashSlice = createSlice({
  name: "dash",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminDashAnalyticsAll.pending, (state) => {
        state.error = null;
        state.analyticsStatus = "pending";
      })
      .addCase(fetchAdminDashAnalyticsAll.fulfilled, (state, action) => {
        state.analyticsAll = action.payload;
        state.analyticsStatus = "succeeded";
      })
      .addCase(fetchAdminDashAnalyticsAll.rejected, (state, action) => {
        state.error = action.payload;
        state.analyticsStatus = "failed";
      })
      .addCase(fetchAdminDashCount.pending, (state) => {
        state.error = null;
        state.getStatus = "pending";
      })
      .addCase(fetchAdminDashCount.fulfilled, (state, action) => {
        state.adminCountsData = action.payload.data;
        state.getStatus = "succeeded";
      })
      .addCase(fetchAdminDashCount.rejected, (state, action) => {
        state.error = action.payload;
        state.getStatus = "failed";
      })
      .addCase(fetchAdminDashTableData.pending, (state) => {
        state.error = null;
        state.getStatus = "pending";
      })
      .addCase(fetchAdminDashTableData.fulfilled, (state, action) => {
        state.adminTableData = action.payload.data;
        state.getStatus = "succeeded";
      })
      .addCase(fetchAdminDashTableData.rejected, (state, action) => {
        state.error = action.payload;
        state.getStatus = "failed";
      })
      .addCase(fetchClientPreview.pending, (state) => {
        state.error = null;
        state.getStatus = "pending";
      })
      .addCase(fetchClientPreview.fulfilled, (state, action) => {
        state.clientPreview = action.payload.data;
        state.totalCount = action.payload.total;
        state.getStatus = "succeeded";
      })
      .addCase(fetchClientPreview.rejected, (state, action) => {
        state.error = action.payload;
        state.getStatus = "failed";
      })
      .addCase(fetchUserQuotePreview.pending, (state) => {
        state.error = null;
        state.getStatus = "pending";
      })
      .addCase(fetchUserQuotePreview.fulfilled, (state, action) => {
        state.userQuotePreview = action.payload.data;
        state.totalCount = action.payload.total;
        state.getStatus = "succeeded";
      })
      .addCase(fetchUserQuotePreview.rejected, (state, action) => {
        state.error = action.payload;
        state.getStatus = "failed";
      })
      .addCase(fetchCollectionPreview.pending, (state) => {
        state.error = null;
        state.getStatus = "pending";
      })
      .addCase(fetchCollectionPreview.fulfilled, (state, action) => {
        state.collectionPreview = action.payload.data;
        state.totalCount = action.payload.total;
        state.getStatus = "succeeded";
      })
      .addCase(fetchCollectionPreview.rejected, (state, action) => {
        state.error = action.payload;
        state.getStatus = "failed";
      })
      .addCase(fetchMovingProductPreview.pending, (state) => {
        state.error = null;
        state.getStatus = "pending";
      })
      .addCase(fetchMovingProductPreview.fulfilled, (state, action) => {
        state.movingProductPreview = action.payload.data;
        state.totalCount = action.payload.total;
        state.getStatus = "succeeded";
      })
      .addCase(fetchMovingProductPreview.rejected, (state, action) => {
        state.error = action.payload;
        state.totalCount = action.payload?.total;
        state.getStatus = "failed";
      })
      .addCase(fetchG3SegementPreview.pending, (state) => {
        state.error = null;
        state.getStatus = "pending";
      })
      .addCase(fetchG3SegementPreview.fulfilled, (state, action) => {
        state.g3SegmentPreview = action.payload.data;
        state.totalCount = action.payload.total;
        state.getStatus = "succeeded";
      })
      .addCase(fetchG3SegementPreview.rejected, (state, action) => {
        state.error = action.payload;
        state.getStatus = "failed";
      })
      .addCase(fetchG4SegementPreview.pending, (state) => {
        state.error = null;
        state.getStatus = "pending";
      })
      .addCase(fetchG4SegementPreview.fulfilled, (state, action) => {
        state.g4SegmentPreview = action.payload.data;
        state.totalCount = action.payload.total;
        state.getStatus = "succeeded";
      })
      .addCase(fetchG4SegementPreview.rejected, (state, action) => {
        state.error = action.payload;
        state.getStatus = "failed";
      })
      .addCase(fetchG5SegementPreview.pending, (state) => {
        state.error = null;
        state.getStatus = "pending";
      })
      .addCase(fetchG5SegementPreview.fulfilled, (state, action) => {
        state.g5SegmentPreview = action.payload.data;
        state.totalCount = action.payload.total;
        state.getStatus = "succeeded";
      })
      .addCase(fetchG5SegementPreview.rejected, (state, action) => {
        state.error = action.payload;
        state.getStatus = "failed";
      })
      .addCase(fetchTopBrandPreview.pending, (state) => {
        state.error = null;
        state.getStatus = "pending";
      })
      .addCase(fetchTopBrandPreview.fulfilled, (state, action) => {
        state.topBrandPreview = action.payload.data;
        state.getStatus = "succeeded";
      })
      .addCase(fetchTopBrandPreview.rejected, (state, action) => {
        state.error = action.payload;
        state.getStatus = "failed";
      })
      .addCase(fetchTodayLoginPreview.pending, (state) => {
        state.error = null;
        state.getStatus = "pending";
      })
      .addCase(fetchTodayLoginPreview.fulfilled, (state, action) => {
        state.todayLoginPreview = action.payload.data;
        state.getStatus = "succeeded";
      })
      .addCase(fetchTodayLoginPreview.rejected, (state, action) => {
        state.error = action.payload;
        state.getStatus = "failed";
      })

      .addCase(fetchUserQuoteByID.pending, (state) => {
        state.error = null;
        state.getStatus = "pending";
      })
      .addCase(fetchUserQuoteByID.fulfilled, (state, action) => {
        state.userQuoteById = action.payload.data;
        state.totalCount = action.payload.total;
        state.getStatus = "succeeded";
      })
      .addCase(fetchUserQuoteByID.rejected, (state, action) => {
        state.error = action.payload;
        state.getStatus = "failed";
      })
      .addCase(fetchOpenSku.pending, (state) => {
        state.error = null;
        state.getStatus = "pending";
      })
      .addCase(fetchOpenSku.fulfilled, (state, action) => {
        state.openSkuUses = action.payload.data;
        state.totalCount = action.payload.total;
        state.getStatus = "succeeded";
      })
      .addCase(fetchOpenSku.rejected, (state, action) => {
        state.error = action.payload;
        state.getStatus = "failed";
      })
      .addCase(fetchOpenCollection.pending, (state) => {
        state.error = null;
        state.getStatus = "pending";
      })
      .addCase(fetchOpenCollection.fulfilled, (state, action) => {
        state.openColletionSkus = action.payload.data;
        state.totalCount = action.payload.total;
        state.getStatus = "succeeded";
      })
      .addCase(fetchOpenCollection.rejected, (state, action) => {
        state.error = action.payload;
        state.getStatus = "failed";
      })
      .addCase(fetchAsProject.pending, (state) => {
        state.error = null;
        state.getStatus = "pending";
      })
      .addCase(fetchAsProject.fulfilled, (state, action) => {
        state.asProject = action.payload.data;
        state.totalCount = action.payload.total;
        state.getStatus = "succeeded";
      })
      .addCase(fetchAsProject.rejected, (state, action) => {
        state.error = action.payload;
        state.getStatus = "failed";
      })
      .addCase(fetchGroheProject.pending, (state) => {
        state.error = null;
        state.getStatus = "pending";
      })
      .addCase(fetchGroheProject.fulfilled, (state, action) => {
        state.groheProject = action.payload.data;
        state.totalCount = action.payload.total;
        state.getStatus = "succeeded";
      })
      .addCase(fetchGroheProject.rejected, (state, action) => {
        state.error = action.payload;
        state.getStatus = "failed";
      });
  },
});

export default dashSlice.reducer;
